// Team roster for the "درباره ما" page (see AboutPage.js). Photos live in
// public/images/members/<slug>.jpg — pre-processed (rotated, resized,
// grayscale) from the raw shoot in the repo-root members/ folder, since
// those originals are multi-megabyte camera JPEGs unfit to ship as-is.
export const HERO_IMAGE = "/images/members/group-hero.jpg";

// The two people running دریچه — shown larger and bolder, above everyone
// else on the page.
export const LEADERSHIP = [
  { slug: "sepehr", name: "سپهر صحرانورد", job: "مدیر مسئول" },
  { slug: "kian", name: "کیان علی‌اصغر", job: "سردبیر" },
  { slug: "seyed_ali", name: "سیدعلی سیدعرب", job: "ناظر علمی" },
];

// Individual editorial/business roles — one person, one job each.
export const EDITORIAL_TEAM = [
  { slug: "hasti", name: "هستی هادی‌نژاد", job: "سر ویراستار" },
  { slug: "paria", name: "پریا بهرامی", job: "مدیر هنری" },
  { slug: "elnaz", name: "النار خان‌زاده", job: "مدیر رسانه" },
  { slug: "kamyar", name: "کامیار بابایی", job: "مدیر اجرایی" },
  { slug: "elina", name: "الینا حسینی", job: "مدیر فروش و مالی" },
];

// Section desks — one job title shared by the two people who run that
// desk together (each source folder had one job .txt for both of them).
export const SECTION_TEAMS = [
  {
    job: "دبیر بخش ویژه",
    members: [{ slug: "zeynab", name: "زینب تبار" }],
  },
  {
    job: "دبیر بخش آزاد",
    members: [{ slug: "amin", name: "محمدامین بهنام" }],
  },
  {
    job: "دبیران بخش برگردان",
    members: [
      { slug: "mahdieh", name: "مهدیه حسن‌نیا" },
      { slug: "mobina", name: "مبینا مرتضوی" },
    ],
  },
  {
    job: "دبیران بخش انگاره",
    members: [
      { slug: "adnan", name: "سید عدنان علوی" },
      { slug: "parsa", name: "محمد پارسا آقاخانی" },
    ],
  },
  {
    job: "دبیران بخش گفت‌وگو",
    members: [
      { slug: "behbod", name: "بهبد بلوری" },
      { slug: "navid", name: "نوید کریمی" },
    ],
  },
  {
    job: "دبیران بخش مرور",
    members: [
      { slug: "ehsan", name: "احسان کمالی" },
      { slug: "reyhane", name: "ریحانه نادری" },
    ],
  },
];

export function memberImage(slug) {
  return `/images/members/${slug}.jpg`;
}
